<ng-template #stepIcon let-step>
    <span class="cm-step" [tp]="Popover" [tpData]="step" tpVariation="light">
        <span class="cm-icon {{ statusClass(step) }}">
            @switch (platformIcon(step)) {
                @case ("compute-engine") {
                    <!-- Compute Engine — processor/chip: pinned die with a windowed core. -->
                    <svg viewBox="0 0 24 24" fill="currentColor" fill-rule="evenodd" aria-hidden="true">
                        <path
                            d="M8.5 1H10v3H8.5zM14 1h1.5v3H14zM8.5 20H10v3H8.5zM14 20h1.5v3H14zM1 8.5h3V10H1zM1 14h3v1.5H1zM20 8.5h3V10h-3zM20 14h3v1.5h-3z"
                        />
                        <path
                            d="M6 4h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Zm3 5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1H9Z"
                        />
                    </svg>
                }
                @case ("cloud-run") {
                    <!-- Cloud Run — the official double-chevron "run" mark, monochrome so it takes the status colour. -->
                    <!-- viewBox is cropped to the glyph's bounds (it occupies only the centre of the source 64-unit box),
                         so it fills its width without the surrounding padding — see the sizing in the SCSS. -->
                    <svg class="cm-cloud-run-glyph" viewBox="19.5 17.5 30 29" fill="currentColor" aria-hidden="true">
                        <path
                            d="M20.5,18.1l4.4,3l3.5,11.2L25,43l-4.5,3l4.3-13.9L20.5,18.1z M31.8,23L34,30h8.2L31.8,23z M49,32.1L28.1,46l4.3-13.9l-4.3-14L49,32.1z"
                        />
                    </svg>
                }
                @case ("render-farm") {
                    <!-- On-prem render farm — server rack. -->
                    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                        <path
                            d="M4 4h16a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1Zm2 2.5v1h2v-1H6Zm10 0v1h2v-1h-2ZM4 14h16a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1Zm2 2.5v1h2v-1H6Zm10 0v1h2v-1h-2Z"
                        />
                    </svg>
                }
            }
            @let filled = dots(step);
            @if (filled !== null) {
                <span class="cm-dots" aria-hidden="true">
                    <span class="cm-dot" [class.cm-filled]="filled >= 2"></span>
                    <span class="cm-dot" [class.cm-filled]="filled >= 1"></span>
                </span>
            }
        </span>
    </span>
</ng-template>

@if ($pinned() && $cascade()[0]; as pinnedStep) {
    <!-- Pinned: no cascade — a pin marker plus the single group it is fixed to. -->
    <span class="cm-cascade">
        <i class="fas fa-thumbtack cm-pin" [matTooltip]="pinTooltip"></i>
        <ng-container [ngTemplateOutlet]="stepIcon" [ngTemplateOutletContext]="{$implicit: pinnedStep}"></ng-container>
    </span>
} @else if ($cascade().length > 0) {
    <span class="cm-cascade">
        @for (step of $cascade(); track step.resourceGroupId; let last = $last) {
            <ng-container [ngTemplateOutlet]="stepIcon" [ngTemplateOutletContext]="{$implicit: step}"></ng-container>
            @if (!last) {
                <span class="cm-caret" aria-hidden="true">›</span>
            }
        }
    </span>
}
